var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('el-container',{staticClass:"content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }